import { tgitems, reactions, citations, substances } from '@Constants';

export const mapContextToTitle = {
  [citations]: 'Documents',
  [substances]: 'Substances',
  [reactions]: 'Reactions',
  [tgitems]: 'Targets',
};

export const contextsOrder = [citations, substances, reactions, tgitems];
